import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import EventsPage from "../pages/events/page";
import LocalGuidePage from "../pages/local-guide/page";
import MamaApprovedPage from "../pages/mama-approved/page";
import WhatTheDuck from "../pages/whattheduck/page";
import LocalResourcesPage from "../pages/local-resources/page";
import PartnerPage from "../pages/partner/page";
import MembershipPage from "../pages/membership/page";
import ThingsToDoPage from "../pages/things-to-do/page";
import MyRsvpsPage from "../pages/my-rsvps/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/events",
    element: <EventsPage />,
  },
  {
    path: "/things-to-do",
    element: <ThingsToDoPage />,
  },
  {
    path: "/local-guide",
    element: <LocalGuidePage />,
  },
  {
    path: "/mama-approved",
    element: <MamaApprovedPage />,
  },
  {
    path: "/whattheduck",
    element: <WhatTheDuck />,
  },
  {
    path: "/local-resources",
    element: <LocalResourcesPage />,
  },
  {
    path: "/partner",
    element: <PartnerPage />,
  },
  {
    path: "/membership",
    element: <MembershipPage />,
  },
  {
    path: "/my-rsvps",
    element: <MyRsvpsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
